import { Pipe, PipeTransform } from '@angular/core';
import { ImportType } from '@app/shared/enums/ImportType.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'importType',
    standalone: false
})
export class ImportTypePipe implements PipeTransform {
  public importType = ImportType;
  public importTypesList: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
   }

  transform(value: any): string {
    if (!value) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedTypes = states
      .map(state => {
        const key = Object.keys(ImportType).find(
          k => ImportType[k as keyof typeof ImportType] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedTypes.length > 0
      ? translatedTypes.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.importTypesList = [];

    for (const [propertyKey, propertyValue] of Object.entries(ImportType)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.importTypesList.push({ id: propertyValue, name: nameAndText, text: nameAndText });
    }

    return this.importTypesList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ImportType)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return { id: propertyValue, name: nameAndText, text: nameAndText };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(ImportType)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
